import i18n from '@/plugins/i18n'

export const hideSAPApprovalView =
  (import.meta.env.VITE_HIDE_APPROVAL_SAP_VIEW && import.meta.env.VITE_HIDE_APPROVAL_SAP_VIEW === 'true') ||
  window.ENV.HIDE_APPROVAL_SAP_VIEW

export const hideStoreToSAPPage =
  (import.meta.env.VITE_HIDE_STORE_TO_SAP_PAGE && import.meta.env.VITE_HIDE_STORE_TO_SAP_PAGE === 'true') ||
  window.ENV.HIDE_STORE_TO_SAP_PAGE

export const someSAPViewIsEnable = !hideSAPApprovalView || !hideStoreToSAPPage

export const SAPReferenceTitle = window.ENV.SAP_REFERENCES_SPECIFICATION_BI_NAMING_ENABLED
  ? // eslint-disable-next-line
    // @ts-ignore
    i18n.global.t('SAP Specification')
  : i18n.global.t('SAP Reference')
